import React, {useMemo} from 'react';
import styles from './PageGrid.module.scss';
import {Breadcrumbs, Icon, Text} from '@gravity-ui/uikit';
import {ActionBar} from '@gravity-ui/navigation';
import {useMatches} from 'react-router';
import {RouterLink} from '../RouterLink';
import {SideBar, SideBarItem} from '../SideBar';
import classNames from 'classnames';
import {Passport} from '@gravity-ui/icons';

export interface BreadcrumbItem {
  text: string;
  href: string;
}

interface PageGridProps {
  title?: string | React.ReactNode;
  actionButtons?: React.ReactNode;
  children: React.ReactNode;
  withSidebar?: boolean;
  sideBarItems?: React.ReactNode | SideBarItem[];
  breadcrumbs?: BreadcrumbItem[];
}

export const PageGrid: React.FC<PageGridProps> = ({
  title,
  actionButtons,
  children,
  withSidebar,
  breadcrumbs,
  sideBarItems,
}) => {
  const matches = useMatches();
  const breadcrumbsData = useMemo(() => {
    if (breadcrumbs && breadcrumbs.length > 0) {
      return breadcrumbs;
    }

    // Иначе используем стандартную логику из роутов
    return matches
      .filter((match) => match.handle && (match.handle as any).crumb)
      .map((match) => ({
        text: (match.handle as any).crumb as string,
        href: match.pathname,
      }));
  }, [matches, breadcrumbs]);

  return (
    <>
      <ActionBar className={styles.actionBar}>
        <nav className={styles.actionBarNav}>
          <Breadcrumbs itemComponent={RouterLink} maxItems={5}>
            {breadcrumbsData.map(({text, href}) => (
              <RouterLink key={href} to={href}>
                {text}
              </RouterLink>
            ))}
          </Breadcrumbs>
        </nav>
        {actionButtons}
      </ActionBar>
      {!withSidebar ? (
        <div className={classNames(styles.pageContent)}>
          {title && <div className={styles.pageHeader}>{title && <Text variant={'header-2'}>{title}</Text>}</div>}
          {children}
        </div>
      ) : (
        <main className={styles.wrapper}>
          <nav className={styles.sideBar}>
            {sideBarItems ? (
              Array.isArray(sideBarItems) ? (
                <SideBar items={sideBarItems} />
              ) : (
                sideBarItems
              )
            ) : (
              <div className={classNames(styles.sideBarItem, styles.sideBarItemCurrent)}>
                <Icon data={Passport} size={18} /> <Text variant={'body-1'}>Учетная запись</Text>
              </div>
            )}
          </nav>
          <div className={classNames(styles.pageContent)}>
            {title && <div className={styles.pageHeader}>{title && <Text variant={'header-2'}>{title}</Text>}</div>}
            {children}
          </div>
        </main>
      )}
    </>
  );
};
